import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Image from "components/landing/image"
import Button from "components/ui/button"
import { cn } from "styles/utils"

const LandingImageRowItem = ({ element, item, lazyload }) => {
  const { title, cta, url, image, style } = item
  const {
    as: TitleComp = "h2",
    className: titleClassName,
    ...titleProps
  } = style?.title_style || {}
  const { className: ctaClassName, ...ctaProps } = style?.cta_style || {}

  return (
    <div className="text-center">
      {image &&
        (url ? (
          <Link
            className="block"
            data-lc={element.anchor_name || element.id}
            to={url}
          >
            <Image image={image} lazyload={lazyload} />
          </Link>
        ) : (
          <Image image={image} lazyload={lazyload} />
        ))}
      {title && (
        <TitleComp
          className={cn("body-lg mt-16 font-semibold", titleClassName)}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
          {...titleProps}
        />
      )}
      {cta && url && (
        <Button
          aria-hidden
          asChild
          className={cn("text-16 leading-16 mt-8 font-medium", ctaClassName)}
          tabIndex="-1"
          text
          underline
          {...ctaProps}
        >
          <Link
            dangerouslySetInnerHTML={{
              __html: cta,
            }}
            data-lc={element.anchor_name || element.id}
            to={url}
          />
        </Button>
      )}
    </div>
  )
}

LandingImageRowItem.propTypes = {
  element: PropTypes.object,
  item: PropTypes.object,
  lazyload: PropTypes.bool,
}

const LandingImageRow = ({ element, lazyload }) => {
  const {
    contain,
    data: { items },
    style,
  } = element
  const { block_style, grid_style } = style || {}
  const { className: blockClassName, ...blockProps } = block_style || {}
  const { className: gridClassName, ...gridProps } = grid_style || {}

  return (
    <div
      className={cn(
        "widescreen:py-60 py-32",
        contain && "contained-wide",
        blockClassName
      )}
      {...blockProps}
    >
      <div
        className={cn(
          "desktop:gap-40 desktop:grid-flow-col tablet:px-32 widescreen:px-60 grid auto-cols-fr grid-flow-row justify-center gap-32 px-16",
          gridClassName
        )}
        {...gridProps}
      >
        {items.map((item, i) => (
          <LandingImageRowItem
            element={element}
            item={item}
            key={`landing-image-row-item-${i}`}
            lazyload={lazyload}
          />
        ))}
      </div>
    </div>
  )
}

LandingImageRow.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingImageRow
